import type { ThemeV2 } from "../util/types";

export const THEME_PREVIEW_READY = "mx8-theme-preview:ready" as const;
export const THEME_PREVIEW_UPDATE = "mx8-theme-preview:update" as const;
export const THEME_PREVIEW_QUESTION = "mx8-theme-preview:question" as const;

export type ThemePreviewQuestionOption = {
  label: string;
  value: string;
};

export type ThemePreviewReadyMessage = {
  type: typeof THEME_PREVIEW_READY;
  version: 1;
  questionTypes: ThemePreviewQuestionOption[];
};

export type ThemePreviewUpdateMessage = {
  type: typeof THEME_PREVIEW_UPDATE;
  version: 1;
  theme: ThemeV2;
};

export type ThemePreviewQuestionMessage = {
  type: typeof THEME_PREVIEW_QUESTION;
  version: 1;
  questionType: string;
};

const isObject = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === "object";

export const isThemePreviewUpdateMessage = (
  value: unknown,
): value is ThemePreviewUpdateMessage =>
  isObject(value) &&
  value.type === THEME_PREVIEW_UPDATE &&
  value.version === 1 &&
  isObject(value.theme) &&
  value.theme.theme_version === "v2";

export const isThemePreviewQuestionMessage = (
  value: unknown,
): value is ThemePreviewQuestionMessage =>
  isObject(value) &&
  value.type === THEME_PREVIEW_QUESTION &&
  value.version === 1 &&
  typeof value.questionType === "string";

export const createThemePreviewReadyMessage = (
  questionTypes: ThemePreviewQuestionOption[],
): ThemePreviewReadyMessage => ({
  type: THEME_PREVIEW_READY,
  version: 1,
  questionTypes,
});

export const getAdminUiOrigin = (): string | null => {
  const allowLocalAdmin =
    import.meta.env.DEV ||
    import.meta.env.VITE_MX8_THEME_PREVIEW_LOCALHOST === "true";
  if (
    allowLocalAdmin &&
    document.referrer &&
    new URL(document.referrer).origin === "http://localhost:8080"
  ) {
    return "http://localhost:8080";
  }
  const domain = import.meta.env.VITE_MX8_ADMIN_UI_DOMAIN;
  if (!domain) return import.meta.env.DEV ? "http://localhost:8080" : null;
  const protocol = import.meta.env.VITE_MX8_ADMIN_UI_PROTOCOL ?? "https";
  try {
    return new URL(`${protocol}://${domain}`).origin;
  } catch {
    return null;
  }
};
